import React, { ReactElement } from 'react';
import { PageStatusCodes } from '@lerna-core';
import { ErrorPageProps, ServerSideResponseWithError } from '@models';
import { getErrorPageData } from '@services';
import { PageNotFoundContainer } from '@features/pageNotFound';
import { ErrorPageContainer } from '@features/errorPage';

const ErrorPage = ({
  statusCode,
  coursesData,
}: ErrorPageProps): ReactElement => {
  if (statusCode === PageStatusCodes.errorNotFound && coursesData) {
    return <PageNotFoundContainer coursesData={coursesData} />;
  }

  return <ErrorPageContainer />;
};

ErrorPage.getInitialProps = async (
  props: ServerSideResponseWithError
): Promise<unknown> => {
  const { res, err } = props;
  const statusCode = res
    ? res.statusCode
    : err
    ? err.statusCode
    : PageStatusCodes.errorNotFound;

  if (res && statusCode === PageStatusCodes.errorNotFound) {
    return getErrorPageData(props, statusCode);
  }

  return { statusCode: PageStatusCodes.serverError };
};

export default ErrorPage;
